<template>
  <cargo-dialog
    id="app"
    :close-on-click-modal="false"
    :visible="visible"
    :title="$t('CargoMsg.Cargo_InvoiceAssociation')"
    append-to-body
    width="1160px"
    top="5vh"
    :can-maximize="true"
    :can-minimize="source==='append'"
    @close="cancel"
  >
    <search-item
      ref="searchItem"
      :show-more-scheme="false"
      :show-simple="false"
      :expand-adv="true"
      :col-settings="{span:12}"
      :search-item-code="$t('SeaExport.AddBillCharge')"
      :config-module="searchItemModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      append-to-body
      @advSearchItemCallBack="fetchData"
    />
    <div class="section grid-wrapper" style="display:flex;flex-grow: 1">
      <cargo-ag-grid
        config-module="190990"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :grid-params.sync="gridParams"
        :row-data="rowData"
        :style="{width:'100%',height:'100%','flex-grow':1}"
      />
    </div>
    <div id="footer-wrapper" class="pagination-wrapper">
      <!--      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">-->
      <!--        <div v-if="totalAmountToCurrencyChargeGrid.selectedCount > 0"><span>选中 {{ totalAmountToCurrencyChargeGrid.selectedCount }}：</span></div>-->
      <!--        <charge-currency-total-group-->
      <!--          v-if="reCalc"-->
      <!--          :amount-to-currency="localCurrency"-->
      <!--          data-field="chargeAmount"-->
      <!--          currency-field="chargeCurrency"-->
      <!--          rate-field="chargeRate"-->
      <!--          ar-field="chargeReceivable"-->
      <!--          type="revenueAbs"-->
      <!--          :data-provider="totalAmountToCurrencyChargeGrid.dataProvider"-->
      <!--        />-->
      <!--      </div>-->
      <cargo-pagination
        config-module="190990"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <div slot="footer">
      <el-button no="1" type="primary" size="mini" @click="enterEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
      <el-button no="2" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </cargo-dialog>

</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected } from '@/utils/agGrid'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { cacheName, cache } from '@/utils/cacheManager'
import { formatNumberToThousands } from '@/utils'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import { Once } from '@/utils/commonUtil'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { queryChargeList } from '@/api/clearing/invoice'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'CollectionAssociationChargeDialog',
  components: { CargoDialog, searchItem, cargoAdvanceSelect, chargeCurrencyTotalGroup, ChargeCountGroup },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultConditions: { type: Object, required: true }, // 弹框打开时默认传递条件
    jobStateParam: { type: String, default: '' },
    chargeStateParam: { type: String, default: '' },
    confirmStateParam: { type: String, default: '' },
    source: { type: String, default: '' },
    searchItemModule: { type: String, default: '5045' }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      innerVisible: this.visible,
      searchItemAutoInit: true,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        pagination: false
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      defaultSearchConditions: {
        accountId: 0, // 结算对象ID
        isAr: -1, // 应收/应付
        oversea: -1, // （国内/国外）
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [] // 费用确认状态
      },
      viewSource: 'BillingDetail_AddCharge', // 默认是账单详情加入费用
      totalAmountToCurrencyChargeGrid: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [],
        chargeCountGroupDataProvider: [] // 弹出框数据源
      },
      once: new Once(this)
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo', width: 150, enableRowGroup: true },
        { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', width: 200 },
        { headerName: this.$t('Invoice.invoice_bookingNo'), field: 'jobBookingNo', width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_paymentApplicationNo'), field: 'billPaymentNo', width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_separateNumber'), field: 'jobHbl', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_billNo'), field: 'billingNo', hide: true, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }, width: 180, enableRowGroup: true },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Invoice.invoice_customer'), field: 'jobCustomerId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, width: 180, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_businessType'), field: 'jobLob',
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'jobVesselFlight', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
          cellRenderer: (params) => {
            let portName = ''
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
          cellRenderer: (params) => {
            let portName = ''
            if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        {
          headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        },
        {
          headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.customerService'), field: 'jobCsr', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Documents'), field: 'jobDc', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Invoice.invoice_sales'), field: 'jobSales',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_operation'), field: 'jobOp',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }, width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_customJobType'), field: 'jobCustomJobType',
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.jobLob, params.data.fba)
          }, width: 140, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'isOversea',
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_paymentType'), field: 'isReceivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_feeStatus'), field: 'chargeState',
          cellRenderer: (params) => {
            return ColumnUtils.chargeStateLabFun(Number(params.value))
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_confirmStatus'), field: 'confirmState',
          cellRenderer: (params) => {
            return ColumnUtils.chargeConfirmStateLabFun(Number(params.value))
          }, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }, width: 130, enableRowGroup: true },
        {
          headerName: this.$t('Payment.unit'), field: 'chargeMeasure', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_ChargeMeasure, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_quantity'), field: 'quantity', width: 100, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 120, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 120, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'verifiedAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 120, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_amountNotWrittenOff'), field: 'unverifiedAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 120, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: 'ETD',
          colId: 'jobEtd',
          field: 'jobEtd',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA',
          colId: 'jobEta',
          field: 'jobEta',
          width: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'),
          colId: 'rate',
          field: 'rate',
          width: 100, minWidth: 100,
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'),
          colId: 'unitRate',
          field: 'unitRate',
          width: 100, minWidth: 100,
          enableRowGroup: true
        }, {
          headerName: this.$t('Payment.auditor'), field: 'chargeAuditor', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.BusinessStatus'),
          field: 'jobState',
          colId: 'jobState',
          cellRenderer: (params) => {
            return ColumnUtils.getJobStateCN(Number(params.value))
          },
          width: 150,
          enableRowGroup: true
        }
      ]
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const defaultConditions = this.defaultConditions
    const defaultSearchConditions = this.defaultSearchConditions
    if (defaultConditions.hasOwnProperty('viewSource')) {
      this.viewSource = defaultConditions.viewSource
    }
    if (defaultConditions.hasOwnProperty('accountId')) {
      defaultSearchConditions.accountId = defaultConditions.accountId
    }
    if (defaultConditions.hasOwnProperty('isAr')) {
      defaultSearchConditions.isAr = defaultConditions.isAr
    }
    if (defaultConditions.hasOwnProperty('commission')) {
      defaultSearchConditions.commission = defaultConditions.commission
    }
    if (defaultConditions.hasOwnProperty('advance')) {
      defaultSearchConditions.advance = defaultConditions.advance
    }
    if (defaultConditions.hasOwnProperty('isNeedInvoice')) {
      defaultSearchConditions.isNeedInvoice = defaultConditions.isNeedInvoice
    }
    if (defaultConditions.hasOwnProperty('shared')) {
      defaultSearchConditions.shared = defaultConditions.shared
    }
    if (defaultConditions.hasOwnProperty('paidOff')) {
      defaultSearchConditions.paidOff = defaultConditions.paidOff
    }
    if (defaultConditions.hasOwnProperty('hasInvoice')) {
      defaultSearchConditions.hasInvoice = defaultConditions.hasInvoice
    }
    if (defaultConditions.hasOwnProperty('oversea')) {
      defaultSearchConditions.oversea = defaultConditions.oversea
    }
    // 默认高级查询条件
    const defaultSearchFields = []
    if (defaultSearchConditions.accountId > -1) {
      // 结算对象
      const accountSearchField = new AdvancedSearchField()
      accountSearchField.itemType = 'company'
      accountSearchField.lock = false
      accountSearchField.defaultValue = []
      accountSearchField.multiple = 0
      accountSearchField.itemLabel = 'Billing.billingJob_settlementCompany'
      accountSearchField.itemName = 'charge.ACCOUNT_ID'
      accountSearchField.fieldType = 'FIELD_COMPANY'
      accountSearchField.defaultSelected = 1
      accountSearchField.selected = 1
      defaultSearchFields.push(accountSearchField.formatObj2Json())
    }
    // 国内国外
    let searchField = new AdvancedSearchField()
    searchField.multiple = 0
    searchField.itemLabel = 'Billing.billingCharge_domesticOrInternational'
    searchField.itemName = 'charge.OVERSEA'
    searchField.fieldType = 'FIELD_CHECKBOX'
    searchField.lock = false
    searchField.selected = 1
    searchField.defaultSelected = 1
    searchField.defaultValue = ''
    searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
    searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
    defaultSearchFields.push(searchField.formatObj2Json())
    // 收支类型
    searchField = new AdvancedSearchField()
    searchField.itemType = 'select'
    searchField.itemCondition = [OperatorConstants.OPERATOR_EQUAL]
    searchField.defaultConditionVal = OperatorConstants.OPERATOR_EQUAL.code
    searchField.itemName = 'charge.ACCOUNT_RECEIVABLE'
    searchField.itemLabel = 'Payment.receivablesAndPayables'
    searchField.dataProvider = ChargeConstants.RECEIVABLE_PAYABLE_TYPES
    searchField.defaultSelected = 1
    searchField.selected = 1
    searchField.lock = true
    searchField.defaultValue = defaultSearchConditions.isAr === 1
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    defaultSearchFields.push(searchField.formatObj2Json())
    // 费用状态配置项
    const billingChargeStates = await LoadDefaultQueryParam.getConfigQueryParam('InvoiceChargeState', ChargeConstants.CHARGE_STATES)
    if (billingChargeStates && billingChargeStates.length > 0) {
      const chargeAuditFlow = Number(cache.config.get('chargeAuditFlow')) === 1
      if (!chargeAuditFlow) {
        for (let i = 0; i < billingChargeStates.length; i++) {
          const chargeState = billingChargeStates[i]
          if (chargeState.code === ChargeConstants.STATE_REJECT.code) {
            billingChargeStates.splice(i, 1)
            break
          }
        }
      }
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_feeStatus'
      searchField.itemName = 'charge.CHARGE_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingChargeStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    // 费用确认状态配置项
    const billingChargeConfirmStates = await LoadDefaultQueryParam.getConfigQueryParam('InvoiceChargeConfirmState', ChargeConstants.CONFIRM_STATES)
    if (billingChargeConfirmStates && billingChargeConfirmStates.length > 0) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.defaultValue = []
      searchField.itemLabel = 'Billing.billingCharge_confirmStatus'
      searchField.itemName = 'charge.CONFIRM_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = billingChargeConfirmStates
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
      this.searchItemAutoInit = true
    }
    this.setLocalCurrency()
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      this.resetResult()
      this.$emit('leavePage')
      this.$emit('update:visible', false)
    },
    resetResult() {
      this.rowData = []
      this.searchConditions.total = 0
      this.totalAmountToCurrencyChargeGrid.dataProvider = []
      this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = []
      this.totalAmountToCurrencyChargeGrid.selectedCount = 0
    },
    fetchData(conditions) {
      this.searchConditions.snapshotConditions = [...conditions]
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    async toAdvQueryList(conditions) {
      this.loading = getLoading()
      // 结算类型中的this.$t('Message.Monthly')是按照大于1来判断的，不能用等于
      for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i]
        if (condition.fieldType === 'settlementType' && condition.value === 1) {
          condition.operator = OperatorConstants.OPERATOR_GREATER.code
          break
        }
      }
      const defaultSearchConditions = this.defaultSearchConditions
      if (defaultSearchConditions.commission !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.COMMISSION', defaultSearchConditions.commission, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (defaultSearchConditions.advance !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.ADVANCE', defaultSearchConditions.advance, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (defaultSearchConditions.isNeedInvoice !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', defaultSearchConditions.isNeedInvoice, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (defaultSearchConditions.shared !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.SHARED', defaultSearchConditions.shared, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (defaultSearchConditions.oversea > -1) {
        const option = new AdvancedSearchOption(null, 'charge.OVERSEA', defaultSearchConditions.oversea, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      if (defaultSearchConditions.paidOff > -1) {
        const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', defaultSearchConditions.paidOff, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(option.formatObj2Json())
      }
      const option = new AdvancedSearchOption(null, 'charge.OFFSET_STATE', 0, OperatorConstants.OPERATOR_EQUAL.code)
      conditions.push(option.formatObj2Json())
      // 是否开票
      if (defaultSearchConditions.hasInvoice !== -1) {
        const option = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', '', OperatorConstants.OPERATOR_IS_NULL.code)
        conditions.push(option.formatObj2Json())
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam('InvoiceJobState', SystemConstants.JOB_STATES) // BillingJobState cargo 未传此参数
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(billingJobState)
          const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用状态
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam('InvoiceChargeState', ChargeConstants.CHARGE_STATES) // BillingChargeState
        if (billingChargeState) {
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeState)
          const condition = new AdvancedSearchOption(null, 'charge.CHARGE_STATE', chargeStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用确认状态
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam('InvoiceChargeConfirmState', ChargeConstants.CONFIRM_STATES)
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(billingChargeConfirmState)
          const condition = new AdvancedSearchOption(null, 'charge.CONFIRM_STATE', confirmStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 默认条件是否有分公司id
      let currentBillingBranchId = this.$store.getters.currentOfficeId
      if (this.defaultConditions.currentBillingBranchId) {
        currentBillingBranchId = this.defaultConditions.currentBillingBranchId
      }
      const requestBody = {
        conditions,
        requires: [],
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        currentBillingBranchId: currentBillingBranchId,
        'requestSource': 'Invoice'
      }
      queryChargeList(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(this.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    enterEvent() { // 确定事件
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      let flag = false
      let statusFlag = false
      const statusData = []
      if (chooseRows && chooseRows.length > 0) {
        for (let i = 0; i < chooseRows.length; i++) {
          const charge = chooseRows[i]
          // 核销状态 - 全部核销
          if (charge['amount'] === charge['verifiedAmount'] && charge['amount'] !== 0) {
            flag = true
          } else {
            statusFlag = true
            statusData.push(charge)
          }
        }
        if (flag) {
          this.$confirm(this.$t('Message.IncludeFullyWrittenOffCosts'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.$emit('addChargeCallBackEvent', chooseRows)
          }).catch((action) => {
            if (action === 'close') {
              return
            }
            if (statusFlag) {
              this.$emit('addChargeCallBackEvent', statusData)
            } else {
              this.$message.warning(this.$t('Message.AllSelectedFeesWillBeVerifiedPleaseChooseAgain'))
            }
          })
        } else {
          this.$emit('addChargeCallBackEvent', chooseRows)
        }
      }
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      this.filterChange()
    },
    filterChange() {
      this.selections = getGridSelected(this.gridOptions)
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvider = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = selections.length
      } else if (arg === 1) {
        this.totalAmountToCurrencyChargeGrid.dataProvider = selections
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvide = this.getChargeCountGroupDataProvider(selections)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyChargeGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyChargeGrid.chargeCountGroupDataProvide = this.getChargeCountGroupDataProvider(this.rowData)
        this.totalAmountToCurrencyChargeGrid.selectedCount = 0
      }
    },
    // 重新组装合计弹出框数据源
    getChargeCountGroupDataProvider(rowData = []) {
      const list = []
      if (rowData && rowData.length > 0) {
        for (const charge of rowData) {
          const map = {
            charge_currency: charge.currency,
            charge_receivable: charge.receivable,
            charge_exchangeRate: charge.rate,
            charge_amount: charge.amount
          }
          list.push(map)
        }
      }
      return list
    },
    toSearchTemplate(value) {
      this.$emit('toSearchTemplate', value)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
